/** Bounded SSE decoding shared by the private bridge and browser transports. */
export class EventStreamDecoder {
  private decoder = new TextDecoder();
  private pending = '';
  push(bytes: Uint8Array): Array<{event: string; data: string}> {
    this.pending = (this.pending + this.decoder.decode(bytes, {stream: true})).replace(/\r\n/g, '\n');
    if (this.pending.length > 4 * 1024 * 1024) throw new Error('The event stream frame exceeded 4 MiB.');
    const frames: Array<{event: string; data: string}> = [];
    let boundary: number;
    while ((boundary = this.pending.indexOf('\n\n')) !== -1) {
      const block = this.pending.slice(0, boundary);
      this.pending = this.pending.slice(boundary + 2);
      let event = 'message';
      const data: string[] = [];
      for (const line of block.split('\n')) {
        if (line.startsWith('event:')) event = line.slice(6).replace(/^ /, '');
        if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
      }
      if (data.length) frames.push({event, data: data.join('\n')});
    }
    return frames;
  }
}
